import { OnBoardingState, ActionTypes, Action } from './types';

import * as data from '../../data/videos.json';

const INITIAL_STATE: OnBoardingState = {
  videos: data.dispenser,
  error: false,
  loading: true,
};

export default function reducer(state = INITIAL_STATE, action: Action): OnBoardingState {
  switch (action.type) {
    case ActionTypes.RESET_STATE:
      return {
        error: false,
        loading: false,
        videos: INITIAL_STATE.videos,
      };

    case ActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        videos: action.videos,
      };

    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };

    default:
      return state;
  }
}
